import { createRouter, createWebHistory } from 'vue-router'
import useAuthStore from '../stores/auth.store';
import useTableStore from '../stores/table.store';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue')
    },
    {
      path: '/productos',
      name: 'productos',
      component: () => import('../views/Products/views/index.vue'),
      params: true
    },
    {
      //404
      path: '/:pathMatch(.*)*',
      name: '404',
      component: () => import('../views/NotFoundView.vue')
    },
    {
      path: '/mercadolibre/devoluciones',
      name: 'devoluciones_ml',
      component: ()=> import('../views/MercadoLibre/Claims/views/index.vue')
    },
    {
      path: '/mercadolibre/ventas',
      name: 'ventas_ml',
      component: ()=> import('../views/MercadoLibre/Orders/views/index.vue')
    },
    {
      path: '/mercadolibre/ventas/:id',
      name: 'ficha_ventas_ml',
      component: ()=> import('../views/MercadoLibre/Orders/views/order_sheet.vue')
    },
    {
      path: '/mercadolibre/preguntas',
      name: 'preguntas_ml',
      component: ()=> import('../views/MercadoLibre/Questions/views/index.vue')
    },
    {
      path: '/mercadolibre/pagos',
      name: 'pagos_ml',
      component: ()=> import('../views/MercadoLibre/Payments/views/index.vue')
    },
    {
      path: '/mercadolibre/pagos/:id',
      name: 'ficha_pagos_ml',
      component: ()=> import('../views/MercadoLibre/Payments/views/payment_sheet.vue')
    },
    {
      path: '/mercadolibre/publicaciones',
      name: 'publicaciones_ml',
      component: ()=> import('../views/Publications/views/index.vue')
    },
    {
      path: '/mercadolibre/publicaciones/:id',
      name: 'ficha_publicaciones_ml',
      component: ()=> import('../views/Publications/views/publication_sheet.vue')
    },
    {
      path: '/configuracion',
      name: 'configuracion',
      redirect: '/configuracion/general'
    },
    {
      path: '/configuracion/:plataforma',
      name: 'configuracion_plataforma',
      props: true,
      component: ()=> import('../views/Settings/views/index.vue')
    },
    {
      path: '/notificaciones',
      name: 'notificaciones',
      component: ()=> import('../views/NotificacionesView.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: ()=> import('../views/LoginView.vue')
    },
    {
      path: '/tareas',
      name: 'tareas',
      component: ()=> import('../views/Tasks/Views/index.vue')
    },
    {
      path: '/usuarios',
      name : 'usuarios',
      component: ()=> import('../views/Users/views/index.vue')
    },
    {
      path: '/productos/ver/:id',
      name: 'ver_producto',
      props: true,
      component: ()=> import('../views/Products/views/product_sheet.vue')
    },
    {
      path: '/images/upload',
      name: 'upload_images',
      component: ()=> import('../views/ImageUploaderView.vue')
    },
    {
      path: '/marcas',
      name: 'marcas',
      component: ()=> import('../views/Brands/views/index.vue')
    },
    {
      // El asistente ocupa la pantalla: no es un modal sobre la ficha.
      path: '/productos/:id/mercadolibre',
      name: 'configurar_mercadolibre',
      component: ()=> import('../views/Products/views/ml_wizard.vue')
    }
  ]
})

router.beforeEach(async (to,from) => {
  
  const tableStore = useTableStore();
  const authStore = useAuthStore();
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  let rutaBase = to.path.match(/\/[^/]+/)
  if (rutaBase == null) rutaBase = '/'
  if (authRequired && !authStore.usuario) {
      authStore.returnUrl = to.fullPath;
      return '/login';
  }
  if (from.path != to.path){
    tableStore.setNumeroItems(0);
  }
});

export default router
